exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".star-score[data-v-0bac2b60]{display:flex}.star-score[data-v-0bac2b60]  svg{margin-right:4px}.star-score[data-v-0bac2b60]  svg:last-child{margin-right:0}.star-score span.clickable[data-v-0bac2b60]{cursor:pointer}.star-score.large[data-v-0bac2b60]  svg{width:24px;height:24px;margin-right:6px}", ""]);

// exports
